import React, { useEffect, useState } from 'react'
import { Form, FormInstance, Input, Select } from 'antd'
import IntlMessages from '../../util/IntlMessages'

import { ISurvey, IQuestionOption } from '@vacationtracker/shared/data/survey'

const { Option } = Select

interface ISurveyProps {
  survey: ISurvey
  form: FormInstance
}

const SurveyFormPart = ({ survey, form }: ISurveyProps): React.ReactElement => {
  
  const [ selectedOption, setSelectedOption ] = useState<IQuestionOption|undefined>()
  const [ selectedSubOption, setSelectedSubOption ] = useState<IQuestionOption|undefined>()

  useEffect(() => {
    const createCompany = JSON.parse(localStorage.getItem('vtCreateCompany') || '{}')
    if(createCompany && createCompany.surveyQuestionOption) {
      setSelectedOption(survey.questions[0].options?.find(option => option.id === createCompany.surveyQuestionOption))
      form.setFieldsValue({ ['surveyQuestionOption']: createCompany.surveyQuestionOption })
    }
    if(createCompany && createCompany.surveyQuestionSuboption) {
      const option = survey.questions[0].options?.find(option => option.id === createCompany.surveyQuestionOption)
      setSelectedSubOption(option?.subQuestion?.options?.find(option => option.id === createCompany.surveyQuestionSuboption))
      form.setFieldsValue({ ['surveyQuestionSuboption']: createCompany.surveyQuestionSuboption })
    }
    if(createCompany && createCompany[`surveyQuestionSpecifyText-${createCompany.surveyQuestionOption}`]) {
      form.setFieldsValue({ [`surveyQuestionSpecifyText-${createCompany.surveyQuestionOption}`]: createCompany[`surveyQuestionSpecifyText-${createCompany.surveyQuestionOption}`] })
    }
    if(createCompany && createCompany[`surveyQuestionSpecifyText-${createCompany.surveyQuestionSuboption}`]) {
      form.setFieldsValue({ 
        [`surveyQuestionSpecifyText-${createCompany.surveyQuestionSuboption}`]: createCompany[`surveyQuestionSpecifyText-${createCompany.surveyQuestionSuboption}`], 
      })
    }
  }, [])

  const onSelectOption = (optionId: string) => {
    setSelectedSubOption(undefined)
    const questionIndex = optionId.split('-')[0] as unknown as number
    const newOption = survey.questions[questionIndex - 1].options?.find(option => option.id === optionId)
    setSelectedOption(newOption)
    form.resetFields(['surveyQuestionSuboption'])
  }

  const onSelectSubOption = (optionId: string) => {
    const newSubOption = selectedOption?.subQuestion?.options?.find(option => option.id === optionId)
    setSelectedSubOption(newSubOption)
    form.setFieldsValue({ ['surveyQuestionSuboption']: newSubOption?.id })
  }

  const textArea = (id: string, name: string, defaultLabel?: boolean): JSX.Element => {
    return (
      <Form.Item
        className='wrap-label'
        label={<IntlMessages id={defaultLabel ? 'surveyAboutUs.textarea' : id} />}
        name={name}
        rules={[{
          required: true, message: <IntlMessages id="error.fieldIsRequired" />,
        }]}
      >
        <Input.TextArea
          rows={3}
          showCount
          maxLength={500}
          data-qa="survey-how-did-you-find-out-about-us"
          className="data-hj-allow"
        />
      </Form.Item>
    )
  }

  return (
    <>
      {survey.questions.map((question, index) => (
        <div key={question.id}>
          <Form.Item
            key={question.id}
            className='wrap-label'
            label={<IntlMessages id={`${survey.id}.Question${index + 1}`} />}
            name='surveyQuestionOption'
            rules={[{
              required: true, message: <IntlMessages id="error.fieldIsRequired" />,
            }]}
          >
            <Select onChange={onSelectOption} className="data-hj-allow">
              {question.options?.map((option) => (
                <Option value={option.id} key={option.name}>
                  <IntlMessages id={`${survey.id}.OptionQuestion${option.id}`} />
                </Option>
              ))}
            </Select>
          </Form.Item>
          {selectedOption && selectedOption.subQuestion && selectedOption.subQuestion.options && (
            <Form.Item
              className='wrap-label'
              label={<IntlMessages id={`${survey.id}.OptionQuestion${selectedOption.subQuestion.id}`} />}
              name="surveyQuestionSuboption"
              rules={[{
                required: true, message: <IntlMessages id="error.fieldIsRequired" />,
              }]}
            >
              <Select onChange={onSelectSubOption} className="data-hj-allow">
                {selectedOption.subQuestion.options
                  .map((option) => (
                    <Option value={option.id} key={option.id}>
                      <IntlMessages id={`${survey.id}.OptionQuestion${option.id}`} />
                      {option.subQuestion && (
                        <Option value={option.subQuestion.id} key={option.subQuestion.name}>
                          <IntlMessages id={`${survey.id}.OptionQuestion${option.id}`} />
                        </Option>
                      )}
                    </Option>
                  ))
                }
              </Select>
            </Form.Item>
          )}
          {selectedSubOption && selectedSubOption.subQuestion && selectedSubOption.subQuestion.textarea && (
            textArea(`${survey.id}.OptionQuestion${selectedSubOption.subQuestion.id}`, `surveyQuestionSpecifyText-${selectedSubOption.id}`, selectedSubOption.defaultLabel)
          )}
          {selectedSubOption && !selectedSubOption.subQuestion && selectedSubOption.textarea && (
            textArea(`${survey.id}.OptionQuestion${selectedSubOption.id}`, `surveyQuestionSpecifyText-${selectedSubOption.id}`, selectedSubOption.defaultLabel)
          )}
          {selectedOption && selectedOption.textarea && (
            textArea(`${survey.id}.OptionQuestion${selectedOption.id}`, `surveyQuestionSpecifyText-${selectedOption.id}`, selectedOption.defaultLabel)
          )}
          {selectedOption && selectedOption.subQuestion && selectedOption.subQuestion.textarea && (
            textArea(`${survey.id}.OptionQuestion${selectedOption.subQuestion.id}`, `surveyQuestionSpecifyText-${selectedOption.id}`, selectedOption.defaultLabel)
          )}
        </div>
      ))}
    </>
  )
}

export default SurveyFormPart